import React from 'react'
import './style.css';

const HowItWorks = () => {
  return (
    <>
      <div style={{ textAlign: "center" }}>
        <h2>How it works ?</h2>
        <video id="video" style={{ width: "700px", margin: "0 auto", maxWidth: "100%", objectFit: "fill" }} poster="" controls>
          <source type="video/mp4" src="https://www.tycl.org.in/girlsleadgirls/service/video/glg-app-tour.mp4"></source>
        </video>
      </div>
    </>
  )
}

export default HowItWorks;